import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { ArrayInput, SimpleFormIterator, TextInput, minValue, number } from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { GridInput } from "../../components/GridForm";
import { NumberInputEx } from "../../components/inputs";
import { ArticleAutocompleteInputAdvanced } from "../orders/Show/Pricelist/ArticleAutocompleteInput";

const useInlineIteratorStyles = makeStyles((theme) => ({
	form: {
		flex: "1 1 auto",
		display: "flex",
		flexWrap: "wrap",

		[theme.breakpoints.down("sm")]: {
			display: "block",
		},

		"& > *": {
			[theme.breakpoints.up("sm")]: {
				marginRight: theme.spacing(2),
			},
		},
	},
}));

const ArticleAutocompleteWithExcludedCodes = (props) => {
	const { values } = useFormState();
	const form = useForm();

	const chosenArticles = values?.articles || [];
	const articleCodes = chosenArticles.map((a) => a && a.article_code);

	const onItemChange = (item) => {
		const base_source = props.source.substring(0, props.source.lastIndexOf("."));
		form.change(`${base_source}.article_service_description`, item.service_description);
		form.change(`${base_source}.article_price`, item.price);
	};

	return (
		<ArticleAutocompleteInputAdvanced
			{...props}
			onItemChange={onItemChange}
			excludeCodes={articleCodes}
		/>
	);
};

export const ArticlesInput = ({ orderRecord, code_patterns, disabled }) => {
	const styles = useInlineIteratorStyles();
	return (
		<ArrayInput source="articles" disabled={disabled}>
			<SimpleFormIterator classes={{ ...styles }}>
				<ArticleAutocompleteWithExcludedCodes
					source="article_code"
					label="resources.deviations.fields.article_code"
					terminal_id={orderRecord.terminal_id}
					company_id={orderRecord.company_id}
					filter={{
						code_patterns: code_patterns,
					}}
					disabled={disabled}
				/>
				<NumberInputEx
					source="article_units"
					label="resources.deviations.fields.article_units"
					component={NumberInputEx}
					type="float"
					digitsCount={1}
					validate={[number(), minValue(0.1)]}
					disabled={disabled}
				/>
				<TextInput
					source="article_service_description"
					label="resources.deviations.fields.article_service_description"
					disabled={disabled}
				/>
			</SimpleFormIterator>
		</ArrayInput>
	);
};
